import { memo } from 'react';
import { cn } from '@divlab/divanui';

import styles from './Video.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface VideoProps extends HTMLAttributes<HTMLDivElement> {
  src: string;
  cnPreviewHeight?: string;
}

const Video: FC<VideoProps> = ({ src, className, cnPreviewHeight, ...restProps }) => {
  return (
    <div {...restProps} className={cn(styles.videoContainer, cnPreviewHeight, className)}>
      <video
        src={src}
        className={styles.video}
        autoPlay
        loop
        crossOrigin='anonymous'
        muted
        playsInline
        preload='auto'
      />
    </div>
  );
};

export default memo(Video);
